<template>
  <div v-drag>
    <a-modal v-model:visible="dialogVisible"
             :bodyStyle="bodyStyle"
             :maskClosable="false"
             :closable="false"
             :footer="null"
             :wrapClassName="'pressDialog'"
             width="720rem">
      <template #title>
        <div class="title">
          反馈
        </div>
      </template>
      <div class="block">
        <span :class="form.category == 0?'isActive':''"
              @click="checkType(0)">
          题目反馈
        </span>
        <span :class="form.category == 1?'isActive':''"
        v-if="form.correct_type!=2"
              @click="checkType(1)">
          批改反馈 
        </span>
        <span :class="form.category == 2?'isActive':''"
              @click="checkType(2)">
          解法反馈 
        </span>
      </div>
      <a-form :colon="false">
        <a-form-item label="反馈">
          <a-textarea placeholder="请输入反馈内容"
                      type="textarea"
                      style="width:100%;height:200rem"
                      v-model:value="form.comment" />
        </a-form-item>
        <a-form-item style="margin-left:60rem"  >
              <span class="desction">
  <info-circle-filled />
  {{
    form.category == 0 ? '题目有错误，反馈内容才有效' :
    form.category == 1 ? '批改有错误，反馈内容才有效' :
    form.category == 2 ? '反馈内容为对解法的意见和建议，才有效' :
    '请选择反馈类型'
  }}
</span>
          </a-form-item>
        <a-form-item label="图片" v-if="form.category==2">
            <div class="img_warp">
            <div class="image"
                 v-for="(item,index) in images"
                 :key="item">
              <a-popconfirm title="确定删除这个图片?"
                            ok-text="确定"
                            cancel-text="取消"
                            @confirm="delteImage(item,index)">
                <img class="close"
                     src="@/static/del.png"
                     alt="">
              </a-popconfirm>

              <a-image :src="addHeader(item)"
                       width="120rem"
                       height="120rem"
                       :key="item">
              </a-image>
            </div>
            <div class="add_img"
             v-if="images.length  != 1"
                 @click="uploadImage">
              <div>
                <img src="@/static/add_img.png"
                     alt="">
              </div>
              点击上传
            </div>
          </div>
        </a-form-item>
        <a-row v-show="form.category=='2'">
          <a-form-item style="margin-left:60rem"  >
              <span class="desction">
 <info-circle-filled />
反馈的解法可拍照上传
</span>
          </a-form-item>
        </a-row>
      </a-form>
      <div class="btn_warp">
        <div @click="handleClose">
          取消
        </div>
        <div @click="save">
          提交
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { reactive, ref } from "@vue/reactivity";
import { message } from "ant-design-vue";
import { topicPress } from '@/api/error.js'
import { uploadImageAuto } from '@/api/upload.js'
import { addHeader as globalAddHeader ,addAllHeader} from '@/init/index.js'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import { InfoCircleFilled } from '@ant-design/icons-vue'
const addHeader = globalAddHeader
let dialogVisible = ref(false)
let form = reactive({})
let images = ref([])
const bodyStyle = {
  padding: 0 // 上 右 下 左
};

const save = async () => {
  console.log(form)
  if (form.comment == '') {
    message.warning('请输入反馈内容')
    return
  }
  let cForm = JSON.parse(JSON.stringify(form))
  if (cForm.category == 0) {
    delete cForm.user_paper_detail_id
  }
  cForm.feedback_image = images.value.join(',')
  await topicPress(cForm)
  dialogVisible.value = false
  message.success('反馈成功')
}

const checkType = (num) => {
  form.category = num
}
const delteImage = (item, index) => {
 
 
 images.value.splice(index, 1)
}
const uploadImage = async (answer_id) => {
   
   
    const { data } = await uploadImageAuto(20, "image/*")
  images.value.push(data.dir)
  message.success('上传成功')
}

const setData = (pForm) => {
  console.log('pForm', pForm)
  for (const key in pForm) {
    form[key] = pForm[key]
  }
  console.log('form', form)
}

const handleClose = () => {
  dialogVisible.value = false
  images.value = []
}

const collect = () => {
  if (topic.has_favorite) {
    message.warning('已经收藏过啦')
    return
  }
  let form = {
    user_paper_detail_id: topic.user_paper_detail_id,
    tags: ''
  }
  // this.$refs.CollectRef.form = form
  // this.$refs.CollectRef.dialogVisible = true
}

defineExpose({
  dialogVisible,
  setData
})
</script>

<style lang="scss"  >
.pressDialog{
  .ant-modal{
  height: 200rem;
 
  top: 20%;
}
.ant-modal-content{
  border-radius:32rem ;
}
.ant-modal-body{
 margin: 22rem 32rem 0rem 32rem !important;
} 
 .ant-form-item-label > label{
  font-size:24rem ;
  margin-top: 110%;
 }
 
.img_warp {
  display: flex;
 
  margin-top: 10rem;
  .image {
    position: relative;
    width: 120rem;
    height: 120rem;
    margin-right: 24rem;
    justify-content: center;
    .close {
      position: absolute;
      right: -5px;
      top: -5px;
      background: red;
      color: white;
      width: 30rem;
      height: 30rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 8px;
      z-index: 19;
    }
  }
  .add_img {
    width: 120rem;
    height: 120rem;
    font-size: 20rem;
    font-weight: 400;
    background: #f6f6f6;
    border-radius: 10rem;
    text-align: center;
    color: #969595;
    cursor: pointer;
    img {
      width: 40rem;
      height: 34rem;
      margin-top: 26rem;
      margin-bottom: 14rem;
    }
     
  }
}
.block {
  display: flex;
  margin-bottom: 20px;
  padding: 0 20rem;
  span {
    width: 128rem;
    height: 48rem;
    font-size: 20rem;
    // font-weight: bold;
    color: #666666;
    border-radius: 8rem;
   background: var(--light-f-5-f-5-f-5, #F5F5F5);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:nth-child(2) {
      margin-left: 24rem;
    }
     &:nth-child(3) {
      margin-left: 24rem;
    }
  }
}
.isActive {
  background: #007af0 !important;
  color: white !important;
}

.desction {
  font-size: 20rem;
  // font-weight: bold;
  color: #F2413A;
}

.btn_warp {
  height: 70rem;
  border-top: 1px solid #e5e5e5;
  display: flex;
  // position: absolute;
  bottom: 0;
  margin-left: -30rem;
  margin-top: 32rem;
  width: 110%;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:nth-child(1) {
      font-size: 24rem;
      font-weight: 400;
      color: #333;
      border-right: 1px solid #e5e5e5;
    }
    &:nth-child(2) {
      font-size: 24rem;
      font-weight: 400;
      color: #2196F3;
    }
  }
}
.ant-form {
  padding: 0 20rem;
}
.ant-form-item  {
 margin-bottom:   10rem !important;
}
:deep .ant-form-item-label > label {
  font-size: 24rem;
  font-weight: 400;
  color: #333333;
  margin-top: 100%;
  margin-right: 8rem;
}
 textarea.ant-input {
 border-radius: var(--Radius-XS, 8px);
 font-size: 24rem;
  font-weight: 400;
  color: #333333;
}
:deep .ant-form-item{
  margin-bottom: 10rem;
}
:deep .ant-input {
  font-size: 24rem;
  font-weight: 500;
  color: #999999;
}
.title {
  font-size: 24rem !important;
}}
</style>